import html2canvas from "html2canvas";

export async function imgToBase64(refs) {
  return Promise.all(
    refs.map(async (ref) => {
      if (!ref?.current) return null;
      const canvas = await html2canvas(ref.current, {
        scale: 1,
        logging: false,
      });
      return canvas.toDataURL("image/png");
    }),
  );
}
